<ng-container *ngIf="showNotifications">
    <unity-toasts [toasts]="notifications" (onClickLink)="onClickLink($event)"></unity-toasts>
</ng-container>